// Segmented choice for pre-game options: one brass plate per option, the chosen one lit and checked
// so the current setting reads at a glance.
import type { ReactNode } from 'react';
import { audio } from '../audio/sfx';

export interface SegOption<T> {
  value: T;
  label: ReactNode;
  tip?: string;
  disabled?: boolean;
}

export function Seg<T extends string | number>({
  label,
  value,
  options,
  onChange,
  readOnly = false,
}: {
  label: string;
  value: T;
  options: SegOption<T>[];
  onChange?: (v: T) => void;
  readOnly?: boolean;
}) {
  return (
    <div className="field">
      <span className="field-label">{label}</span>
      <div className={`seg ${readOnly ? 'read-only' : ''}`} role="radiogroup" aria-label={label}>
        {options.map((o) => {
          const on = o.value === value;
          return (
            <button
              key={String(o.value)}
              type="button"
              role="radio"
              aria-checked={on}
              className={`seg-opt ${on ? 'is-on' : ''}`}
              disabled={o.disabled || (readOnly && !on)}
              data-tip={o.tip}
              onClick={() => {
                if (readOnly || on) return;
                audio.play('select');
                onChange?.(o.value);
              }}
            >
              {o.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}

export const TIMER_OPTIONS = [
  { value: 'off', label: 'Off', tip: 'No timer|Take as long as you like — best among friends.' },
  { value: 'relaxed', label: '2 min', tip: 'Relaxed|2 minutes per turn.' },
  { value: 'standard', label: '1 min', tip: 'Standard|1 minute per turn.' },
  { value: 'blitz', label: '30 s', tip: 'Blitz|30 seconds per turn.' },
  { value: 'async', label: 'Async', tip: 'Async|24 hours per turn — play over days.' },
] as const;

